import { PropTypes } from "prop-types"

export function ModalContent({ children }) {
  return <div className="oj-modal-content">{children}</div>
}

ModalContent.propTypes = {
  children: PropTypes.node
}

export default ModalContent
